import * as React from 'react'

function SvgHangup(props, svgRef) {
  return (
    <svg viewBox="0 0 37 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}>
      <path
        d="M4.627 13.818l-2.758-2.757a2.6 2.6 0 01.165-3.843 25.727 25.727 0 0110.756-5.11 25.35 25.35 0 0111.03 0 25.727 25.727 0 0110.792 5.147 2.6 2.6 0 01.175 3.833l-2.758 2.758a2.6 2.6 0 01-3.42.257 16.693 16.693 0 00-3.226-1.94 2.6 2.6 0 01-1.526-2.353V7.476a20.8 20.8 0 00-11.03 0V9.81a2.6 2.6 0 01-1.527 2.354 16.694 16.694 0 00-3.226 1.94 2.6 2.6 0 01-3.447-.286z"
        stroke="#fff"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

const ForwardRef = React.forwardRef(SvgHangup)
export default ForwardRef
